// MenuItems.js
const Menuitems = [
  {
    id: 1,
    label: "Dashboard",
    link: "/admin/dashboard",
  },
  {
    id: 2,
    label: "Master",
    submenus: [
      {
        id: 1,
        label: "Settings",
        link: "/admin/settings",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      }
    ],
  },
  {
    id: 3,
    label: "Users",
    submenus: [
      {
        id: 1,
        label: "All Users",
        link: "/admin/all-users",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 2,
        label: "Update User",
        link: "/admin/update-user",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 3,
        label: "Update User Wallet",
        link: "/admin/update-wallet",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },  
     
    ],
  },
  {
    id: 4,
    label: "Products",
    submenus: [
      {
        id: 1,
        label: "All Products",
        link: "/admin/all-products",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 2,
        label: "Add New Products",
        link: "/admin/add-products",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 3,
        label: "Inventory Update",
        link: "/admin/inventory-update",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      // {
      //   id: 4,
      //   label: "Update Product",
      //   link: "/admin/update-payout",
      //   img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
      //   desc: "Hello this is description for the sub menu."
      // },
    ],
  },
  {
    id: 5,
    label: "Orders",
    submenus: [
      {
        id: 1,
        label: "All Orders",
        link: "/admin/all-orders",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      {
        id: 2,
        label: "Update Order",
        link: "/admin/update-order",
        img: "https://res.cloudinary.com/dev6cpp4u/image/upload/v1690181271/invest_yss3bh.png",
        desc: "Hello this is description for the sub menu."
      },
      
      
    ],
  },
  
  {
    id: 6,
    label: "Log out",
    link: "/logout",
  },

];

export default Menuitems;
